import * as React from 'react';
import qrUret from 'qrcode-generator';

/**
 * QR'i SVG olarak cizer.
 *
 * `<img>` ya da canvas kullanmiyoruz: SVG yazicida her boyutta keskin cikar,
 * baski onizlemesi ek bir yukleme beklemez ve karanlik ekranda da beyaz
 * zeminiyle okunur kalir.
 */
export function QrKod({
  deger,
  boyut = 132,
  renk = '#0b1530',
}: {
  deger: string;
  boyut?: number;
  renk?: string;
}) {
  const yol = React.useMemo(() => {
    // Tip 0 = otomatik boyut, 'M' = %15 hata duzeltme (kagit uzerinde yeterli)
    const qr = qrUret(0, 'M');
    qr.addData(deger);
    qr.make();
    const n = qr.getModuleCount();
    const parcalar: string[] = [];
    for (let satir = 0; satir < n; satir++) {
      for (let sutun = 0; sutun < n; sutun++) {
        if (qr.isDark(satir, sutun)) parcalar.push(`M${sutun} ${satir}h1v1h-1z`);
      }
    }
    return { d: parcalar.join(''), n };
  }, [deger]);

  return (
    <svg
      width={boyut}
      height={boyut}
      viewBox={`0 0 ${yol.n} ${yol.n}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label={deger}
    >
      <rect width={yol.n} height={yol.n} fill="#fff" />
      <path d={yol.d} fill={renk} />
    </svg>
  );
}
